import { Outlet } from 'react-router-dom';
import Navigation from '../components/Navigation.jsx';
import Footer from '../components/Footer.jsx';
import ScrollToTop from '../components/ScrollToTop.jsx';

// Wrapper für alle Public-Pages: Nav oben, Seiteninhalt in der Mitte, Footer unten.
// ScrollToTop sorgt für korrektes Scroll-Verhalten bei Route-Wechseln.
export default function SiteLayout() {
  return (
    <>
      <ScrollToTop />
      <Navigation />
      <main id="main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
